/**
 * @generated SignedSource<<5bf708d12cdf3b157f5adf7b05d3fe8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUserFavouriteProjectsInput = {
  favouriteProjects: ReadonlyArray<number>;
};
export type UserFavouriteProjectsMutation$variables = {
  input: UpdateUserFavouriteProjectsInput;
};
export type UserFavouriteProjectsMutation$data = {
  readonly updateUserFavouriteProjects: {
    readonly user: {
      readonly favourite_projects: any;
      readonly id: number;
    } | null | undefined;
  };
};
export type UserFavouriteProjectsMutation = {
  response: UserFavouriteProjectsMutation$data;
  variables: UserFavouriteProjectsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserFavouriteProjectsPayload",
    "kind": "LinkedField",
    "name": "updateUserFavouriteProjects",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "users",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "favourite_projects",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserFavouriteProjectsMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserFavouriteProjectsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f63b45738f7d7bb1e9136f9ef25ddb1e",
    "id": null,
    "metadata": {},
    "name": "UserFavouriteProjectsMutation",
    "operationKind": "mutation",
    "text": "mutation UserFavouriteProjectsMutation(\n  $input: UpdateUserFavouriteProjectsInput!\n) {\n  updateUserFavouriteProjects(input: $input) {\n    user {\n      id\n      favourite_projects\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d62a3a523bdf53be2beda08f52f58c16";

export default node;
